import { useEffect } from "react";

/**
 * Subscribe a load()-style callback to the global "kirana:revalidate" event
 * fired by api.js whenever the tab regains focus or visibility. Use this in
 * list-view pages so cross-device changes reflect the moment the user
 * switches back to the laptop / mobile tab.
 *
 *   useRevalidate(() => api.get("/items").then((r) => setItems(r.data)));
 */
export default function useRevalidate(cb) {
  useEffect(() => {
    const handler = () => { try { cb(); } catch (e) { /* swallow */ } };
    window.addEventListener("kirana:revalidate", handler);
    return () => window.removeEventListener("kirana:revalidate", handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
